/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import styles from "./index.module.css";
import GroupPeople from "../../images/Group-people.jpg"
import MarkIcon from "../../images/mark.png"

const WhySunWest = () => {

  const getSunWestSuccessYears = () => {
    //Sun West founded in 08/12/1980
    const foundedDate = new Date('1980-08-12');
    const todayDate = new Date();    
    const yearDiff = todayDate.getFullYear() - foundedDate.getFullYear();
    const isDate2BeforeBirthday = (
    todayDate.getMonth() < foundedDate.getMonth() ||
    (todayDate.getMonth() === foundedDate.getMonth() && todayDate.getDate() < foundedDate.getDate())
    );
    return isDate2BeforeBirthday ? yearDiff - 1 : yearDiff;
    }
    
  const whySunWestList1 = [
    `No Overlays. We underwrite on Agency Investor Guidelines Only`,
    "Down to 500 FICO on FHA/VA",
    "Nationwide Presence",
    `We’ve been in business over ${getSunWestSuccessYears()} years!`,
  ];
  const whySunWestList2 = [
    "Manual Underwriting Allowed on FHA, VA and USDA Loans",
    "Industry Leading Low Rates",
    "Extensive Marketing Support",
    "Full Medical, Dental, Vision & 401K",
  ];
   
   
  return (
    <Container fluid className={styles.section}>
      <div className={styles.div}>
        <Image fluid src={GroupPeople} width="1200px" height="340px" />
      </div>
      <div className={styles.div}>
        <span className={styles.whyText}>Why</span>
        <span className={styles.sunWestText}>Sun West?</span>
      </div>
      <div className={styles.div}>
        <div className={styles.paraText}>
          A Sun West Career puts you in charge of your own
          mortgage loan officer salary. We are focused on protecting your
          reputation and brand with your referral partners and borrowers. While
          our competitors have forgotten how personal loan origination is, Sun
          West, led by experienced loan originators, has developed a superior
          manufacturing process that is built on {getSunWestSuccessYears()} years of experience,
          people-powered technology, and exceptional engineering. Your loan
          closings at Sun West will be predictable, consistent, and fast! Plus,
          we’ll support you with marketing strategies including loan officer
          marketing, social media marketing and marketing to realtors.
        </div>
      </div>
      <div className={styles.div}>
        <Row className={`${styles.lists} no-gutters`}>
          <Col sm={12} md={6}>
            {whySunWestList1.map((x, id) => {
              return (
                <div key={id} className={styles.listDiv}>
                  <span style={{ textAlign: "right" }}>
                    <Image
                      className={styles.checkMarkImage}
                      src={MarkIcon}
                      width="22px" 
                      height="19px"
                      alt="Mark Icon"
                    />
                  </span>
                  <span className={styles.listText}>{x}</span>
                </div>
              );
            })}
          </Col>
          <Col sm={12} md={6}>
            {whySunWestList2.map((x, id) => {
              return (
                <div key={id} className={styles.listDiv}>
                  <span style={{ textAlign: "right" }}>
                    <Image
                      className={styles.checkMarkImage}
                      src={MarkIcon}
                      width="22px" 
                      height="19px"
                      alt="Mark Icon"
                    />
                  </span>
                  <span className={styles.listText}>{x}</span>
                </div>
              );
            })}
          </Col>
        </Row>
      </div>
      <div className={styles.div}>
        <div className={styles.raise}>
          <span className={styles.itsTimeText}>
            It's Time You Give
            <br />
            Yourself a
          </span>
          <span className={styles.raiseText}>Raise</span>
        </div>
      </div>
    </Container>
  );
};

export default WhySunWest;
